import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Forbidden = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Compte à rebours pour la redirection
    const intervalId = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    // Redirection vers la page d'accueil après 5 secondes
    const redirectTimer = setTimeout(() => {
      navigate("/");
    }, 5000);

    // Cleanup du timer et de l'intervalle si le composant est démonté
    return () => {
      clearTimeout(redirectTimer);
      clearInterval(intervalId);
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-indigo-50 to-purple-50 relative overflow-hidden px-4">
      {/* Cercles décoratifs */}
      <div className="absolute top-20 left-20 w-64 h-64 rounded-full bg-purple-100 opacity-40 mix-blend-multiply filter blur-xl"></div>
      <div className="absolute bottom-20 right-20 w-80 h-80 rounded-full bg-indigo-100 opacity-40 mix-blend-multiply filter blur-xl"></div>
      <div className="absolute top-1/3 right-1/3 w-40 h-40 rounded-full bg-pink-100 opacity-30 mix-blend-multiply filter blur-lg"></div>
      
      {/* SVG décoratifs */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
        <svg className="absolute top-0 left-0 opacity-20" width="100%" height="100%" viewBox="0 0 800 800">
          <path d="M0,0L60,53.3C120,107,240,213,360,240C480,267,600,213,720,202.7C840,192,960,224,1080,229.3C1200,235,1320,213,1380,202.7L1440,192L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z" fill="#6366f1" fillOpacity="0.1"></path>
        </svg>
        <svg className="absolute bottom-0 right-0 opacity-20" width="100%" height="100%" viewBox="0 0 800 800">
          <path d="M0,320L48,288C96,256,192,192,288,186.7C384,181,480,235,576,245.3C672,256,768,224,864,224C960,224,1056,256,1152,261.3C1248,267,1344,245,1392,234.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="#8b5cf6" fillOpacity="0.1"></path>
        </svg>
      </div>

      <div className="relative z-10 max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        {/* Barre rouge en haut */}
        <div className="h-2 bg-gradient-to-r from-red-500 to-red-600"></div>
        
        <div className="p-8">
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 rounded-full bg-red-50 flex items-center justify-center">
              <svg className="w-12 h-12 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
            </div>
          </div>

          <h1 className="text-center mb-4 text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-red-700">
            403
          </h1>
          <h2 className="text-center mb-6 text-2xl font-bold text-gray-800">
            Accès Interdit
          </h2>
          <p className="mb-6 text-center text-gray-600">
            Vous n'avez pas les permissions nécessaires pour accéder à cette page. Veuillez contacter un administrateur si vous pensez qu'il s'agit d'une erreur.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button 
              onClick={() => navigate("/")}
              className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-lg transition-colors w-full sm:w-auto text-center"
            >
              Retour à l'accueil
            </button>
            <button 
              onClick={() => navigate(-1)}
              className="px-6 py-3 border border-gray-300 hover:border-gray-400 text-gray-700 font-medium rounded-lg transition-colors w-full sm:w-auto text-center"
            >
              Page précédente
            </button>
          </div>
          
          <div className="mt-6 text-center">
            <div className="inline-flex items-center justify-center">
              <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-800 font-semibold">{countdown}</div>
              <span className="ml-2 text-sm text-gray-500">Redirection automatique dans {countdown} seconde{countdown !== 1 ? 's' : ''}</span>
            </div>
          </div>
        </div>
        
        {/* Motif en bas */}
        <div className="h-2 bg-gradient-to-r from-indigo-500 to-purple-600"></div>
      </div>
      
      {/* SVG décoratif du bas */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="opacity-30">
          <path fill="#6366f1" fillOpacity="0.2" d="M0,288L48,272C96,256,192,224,288,213.3C384,203,480,213,576,229.3C672,245,768,267,864,261.3C960,256,1056,224,1152,213.3C1248,203,1344,213,1392,218.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </div>
  );
};

export default Forbidden;